import React from 'react';
import styled from 'styled-components';

import Text from '../../basic/Text';
import Link from '../../util/link';
import Event from '../../util/GAEvent';
import theme from '../../../styles/theme';

const {
	breakPoints: { screenQuery },
} = theme;

const FadeInDiv = styled.div`
	transition-duration: 0.5s;
`;

const CTAMenu = styled.div`
	display: flex;
	align-items: center;

	* {
		font-size: 14px;
	}
	${screenQuery.large} {
		margin-right: 70px;
	}
`;

const CTAPill = styled(Text)`
	transition-duration: ${theme.transitionDuration};
	margin-left: 20px;
	border: 2px solid ${theme.colors.brandMain};
	border-radius: 30px;

	&.cta-button {
		a {
			color: ${theme.colors.brandMain};
			font-family: ${theme.font.bold};
			letter-spacing: 0.5px;
			display: block;
			padding: 10px 24px;
		}
	}
	:hover {
		background-color: ${theme.colors.brandMain};
		a {
			color: ${theme.colors.grayscale.white};
		}
	}
	${screenQuery.small} {
		display: none;
	}
`;

const CTASection = () => {
	return (
		<FadeInDiv>
			<CTAMenu>
				<Text
					component="b3"
					id="header-sign-in-button"
					className="header-sign-in-button"
				>
					<Link bold={1} color="black" hovercolor="brandMain" to="/sign-in">
						<Event
							action={`Clicked sign-in button`}
							category="User"
							label="Sign In"
							value="Sign In"
						>
							Sign In
						</Event>
					</Link>
				</Text>
				<CTAPill className="cta-button" component="b3">
					<Link bold={1} to="/contact-sales/">
						<Event
							action={`Clicked "talk to an sales" in Nav`}
							category="User"
							label="Submittable User"
						>
							Talk to Sales
						</Event>
					</Link>
				</CTAPill>
			</CTAMenu>
		</FadeInDiv>
	);
};

export default CTASection;
